import React from 'react'
import "./home.css"
import BigButton from '../utils/BigButton/BigButton'
import { Link } from 'react-router-dom'
import { useLangContext } from '../../Context/LangContext'
import homeTexts from '.././utils/Texts/homeTexts.json'
import HomeVideo from './video/AFZ02.mp4'
import { useEffect} from 'react'
import { MobileOnlyView, isMobileOnly } from 'react-device-detect';
import { Icon } from '@iconify/react'


import HomeMobile from './HomeMobile'

const Home = () => {
const { selectedLanguage } = useLangContext()
const text = homeTexts[selectedLanguage];




useEffect(()=>{
  window.scrollTo(0,0);
},[])

  return (
   <>
   
    <div className={isMobileOnly ? "display-none":'homeBackgound'}>
      <video autoPlay playsInline muted className='home-video'>
        <source src={HomeVideo} type='video/mp4' />
      </video>
      <div className='gradient'>
      <div className='hero'>
        <div className='BLogo-box'>
         
          <img src="img/Empressa-Certificada-Logo-White-RGB.png" alt="Empresa Certificada Logo" className='BLogo' />
      
          </div>
          
        <div className='homeTitle'>
         
        <h1>{text.title1}<br></br>{text.title2}</h1>
        <div className='call-to-action-container'>
        <div className='call-to-action-box'>
          <div className='call-texts'>
        <h2>{text.callToAction}</h2>
        <h4>{text.callSubtitle}</h4>
        </div>
        <Link to="/cotizador-alquiler">
       
<button className="call-button">
  {text.callButton}
<Icon icon="mdi:arrow-right" className='call-arrow'/>

</button>
        </Link>
        </div>
        <div className='button-box'>
      <Link to="/cotizador-directores">
        <BigButton className="dark-button-home-directors" name={text.contactButton}  />
        </Link>
        </div>
        </div>
        </div>
        
        <div className='button-box'>
        
       
       
      
        </div>
      
      </div>
      </div>
    </div>
   
    <MobileOnlyView>
   <HomeMobile />
    </MobileOnlyView>
    </>
   
  )
}

export default Home
